import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import useTranslation from 'shared/hooks/useTranslation';
import BADGES, { BADGES_LANGUAGES } from '../badgesData';
import HeaderSection from './Header';

function Mobile(): JSX.Element {
  const { t, lang } = useTranslation('badgesPage');

  const Wrapper = styled.section`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 4rem;
    text-align: center;
    padding: 0 2.4rem;

    ${({ theme }) => theme.MEDIA.MD} {
      display: none;
    }
  `;

  const BadgeSection = styled.div`
    margin: 4rem 0;
  `;

  const BadgeImg = styled.div``;

  const BadgeName = styled.h2`
    color: ${({ theme }) => theme.COLORS.SECONDARY};
    font-size: 3.2rem;
    margin-bottom: 1.6rem;
  `;

  const BadgeDescription = styled.div`
    font-size: 1.8rem;

    b {
      font-size: 1.2em;
    }
  `;

  return (
    <Wrapper>
      <HeaderSection />
      {BADGES.map(({ id, name, src }) => (
        <BadgeSection key={id}>
          <BadgeImg>
            <Image
              src={`/img/badges/v2/${BADGES_LANGUAGES.includes(lang) ? lang : 'en'}/${src}.svg`}
              alt="name"
              width={180}
              height={180}
              layout="fixed"
              lazyBoundary="1000px"
            />
          </BadgeImg>
          <BadgeName>{t(`badges.${name}`)}</BadgeName>
          <BadgeDescription dangerouslySetInnerHTML={{ __html: t(`badges.description.${name}`) }} />
        </BadgeSection>
      ))}
    </Wrapper>
  );
}

export default Mobile;
